//
// TRIL-116: completion percentage widget per spec §366. Shows 3 sections:
// required, optional, verified (TRIL-90/91 placeholder).

import { Check, Lock } from 'lucide-react';
import * as React from 'react';
import { computeCompletionPct } from '../../../helpers/planCCompletion';
import type { ProfessionalContext } from '../../../interfaces/user.interface';
import './completion-percentage-widget.scss';

interface Props {
  context: ProfessionalContext | null;
}

export function CompletionPercentageWidget({
  context,
}: Props): React.ReactElement {
  const snap = computeCompletionPct(context);
  return (
    <div className="completion-widget">
      <div className="completion-widget__header">
        <span className="completion-widget__heading">
          {snap.filled} of {snap.total} sections complete
        </span>
      </div>
      <ul className="completion-widget__list">
        <li
          className={
            snap.sections.required
              ? 'completion-widget__item complete'
              : 'completion-widget__item'
          }
        >
          {snap.sections.required && <Check size={14} />}
          <span>Expertise areas + education</span>
        </li>
        <li
          className={
            snap.sections.optional
              ? 'completion-widget__item complete'
              : 'completion-widget__item'
          }
        >
          {snap.sections.optional && <Check size={14} />}
          <span>Optional details (job title, experience, credentials)</span>
        </li>
        <li className="completion-widget__item locked">
          <Lock size={14} />
          <span>Verified credentials</span>
          <span className="completion-widget__badge">Coming soon</span>
        </li>
      </ul>
    </div>
  );
}
